export const LANG = {
  en: {
    LANGUAGE: 'en',
    ARTICLES: {
      QUESTIONS: {
        AGREE_INFO_RAPPI:
          'Are you happy with the information provided by your Rappi?',
        HOW_SOLVE_YOUR_PROBLEM: 'How would you like us to solve your problem?',
        KIND_OF_DOUBT: 'Kind of doubt',
        KIND_OF_DAMAGE_ORDER: 'What kind of damage did your order have?',
        PRODUCT_BAD_STATUS: 'What product did you get in poor condition?',
        USER_COMMENT: 'User comment:',
        PRODUCT_DESCRIPTION: 'Relate products in this order',
      },
    },
    HOME: {
      TITLE: 'Homepage',
    },
    NOT_FOUND: {
      TITLE: 'The requested page was not found',
    },
    WIDGETS: {
      BILLING_INFORMATION: {
        CHARGE_DEDUCTED: 'Charge deducted from your card',
        COUPON_DISCOUNT: 'Coupon discount',
        DELIVERY_COST: 'Delivery cost',
        DIFFS_PERSONAL_SHOPPER: 'Price difference personal shopper',
        DISCOUNTS: 'Discounts',
        OTHER_TOTAL_CHARGES: 'Other charges',
        PRIME_DISCOUNT: 'Prime Discount',
        PRODUCT_DISCOUNT_BY_RAPPI: 'Product discounts by rappi',
        PRODUCT_DISCOUNT_BY_STORE: 'Product discounts by store',
        PROMOTION_DISCOUNT: 'Promotion discount',
        SUBTOTAL_PRODUCTS: 'Subtotal products',
        SUPPORT_DISCOUNT: 'Lupe discounts',
        TOTAL_COSTS: 'Total costs',
        TOTAL_DISCOUNTS: 'Total discounts',
        TOTAL_PAID_BY: 'Total paid by ',
        TOTAL_PAYMENTS: 'Total payments',
        TRANSACTIONS_TO_YOUR_CARD: 'Transactions to the card',
        WHIM_COST: 'Whim costs',
      },
      CALL_RT: {
        YOUR_RAPPI: 'Your Rappi',
      },
      CALL_RESTAURANT: {
        TITLE: 'Call restaurant',
        YOUR_ORDER_ID: 'Your order code is',
      },
      CALL_SUPPORT: {
        TITLE: 'Call support',
        HOW_CALL: 'How do you want to call ?',
        PHONE: 'Phone',
        DATA: 'Data',
        SIMPLE_CALL_SUPPORT: 'call support',
        THIS_IS_AN_ERROR: 'If you think this is a mistake, ',
      },
      CLOSE_REQUEST: {
        TITLE: 'Finalize order',
      },
      COMMON: {
        MESSAGE_SEND: 'Message sent!',
        CONTACT_EMAIL: `We'll contact you by email`,
        LEGAL_TIME: 'In less than 72 hours we will have an answer.',
        AND_SUPPORT_SECTION_APP: 'and in the Support section of the app',
        UNDERSTOOD: 'Understood',
        OK: 'OK!',
        RATE_US: 'Please rate our services...',
        REQUEST_ERROR:
          'It was not possible to process your request. Please try again in some minutes.',
        DOWNLOAD_DOCUMENT_COPY: 'Get a copy',
        HERE: 'here'

      },
      DEEP_LINK_CART: {
        ALREADY_APPLIED_RAPPICREDITS:
          'We have already applied Créditos to your account so that you ask for what you want.',
      },
      OPTION_LIST: {
        TITLE: 'Choose an option',
        PLEASE_COMPLETE: 'please tell us {question}',
      },
      RT_DISPERSION: {
        GET_INTO: 'Enter',
        AMOUNT: 'the amount',
        CONFIRMATION: 'We have received your request for dispersion!',
        IN_REVISION:
          'We are already reviewing your request, in a few minutes we will give you the answer',
      },
      TIMER: {
        IMMEDIATE_HELP: 'Do you need immediate help?',
        IN_THE_NEXT: 'During the next',
        MINUTES_OPEN_ORDER:
          'minutes this order will be open to solve any problem',
        DIALOG_TITLE: 'Information',
        DIALOG_TEXT: 'If you need help with this order, visit the Help Center',
        DIALOG_CLOSE_BUTTON: 'Understood',
      },
      TRANSACTION_DETAIL: {
        TYPE: 'Type',
        AMOUNT: 'Amount',
        DATE: 'Date',
        COPY:
          'In the following table you can see the different transactions made to your card. Sometimes we make a pre-authorization to your account, this is not a charge as such but a reservation that allows us to verify that you have enough balance to pay the order at the time of delivery',
        INFO_BOX: {
          COPY: 'Depending on your bank, it may take a while to update',
        },
        TOTAL_COPY: 'Full payment',
      },
      PRODUCTS_WRAPPER: {
        WHIMS: 'Antojos',
      },
      INPUT: {
        MAX_LENGTH: 'You have reached the maximum of characters',
      },
      TEXT_AREA: {
        PLACEHOLDER: 'Write here',
        TITLE: 'Write us your message',
      },
      BUTTON: {
        SEND: 'Send',
      },
      CLOSE_REORDER_PRODUCTS_FLOW_WIDGET: {
        COVID_19:
          'Due to the current scenario and increased demand, our service operations are operating at maximum capacity. We count on your understanding because it may take longer than usual to reply you.',
      },
      HELP_OPTIONS: {
        TITLE: 'Do you have problems with your order?',
      },
      MULTIPLE_ATTENTION_CHANNELS: {
        TITLE: 'Please provide additional details',
        BODY: 'Tell us in detail what happened',
        EMAIL: 'Send',
        CHAT: 'Or Chat',
        CHANNEL_SUBTITLE: 'Channel through which you want to be attended',
        ONLY_ONE_CHANNEL_CHAT: 'Return to my chat',
        ONLY_ONE_CHANNEL_TICKET: 'Return to my request'
      },
      COST_DISCOUNTS: {
        COST_MESSAGE: 'Your charge',
        COST_TITLE: 'Costs',
        DISCOUNT_TITLE: 'Discounts',
        IVA: 'The total price includes VAT',
        MODAL_SERVICE_FEE: {
          TITLE: 'Service fee',
          TEXT: `It's an additional fee charged by the Rappi platform to the user/consumer for purchases on Rappi's commercial partners. This fee helps cover costs of technology, development of the app’s new features, marketing actions and payments platform costs.`,
        },
      },
      PAYMENTS_RT: {
        PUBLIC_COMMENT_RANGE: 'Date: {range}',
        PUBLIC_COMMENT_AMOUNT: 'Amount: {amount}',
        NO_PAYMENTS: 'No records found',
        PAYMENTS_SELECT_WARNING_TOAST: 'Please select a date range.',
        PAYMENTS_TEXT_TOAST:
          'We have made a payment to your registered account.',
        PAYMENTS_TEXT_FIRST:
          'We have made a payment to your registered account by',
        PAYMENTS_TEXT_LAST:
          'any additional concerns about this payment, please do it from your balance or debt options.',
        USER_DEBT:
          'The debt in this period was greater than the earnings and no deposit was made.',
        DATE_PLACEHOLDER: 'Select date',
        AMOUNT_PLACEHOLDER: 'Pending Amount (optional)',
      },
      SCREEN_SATISFACTION: {
        TITLE: 'I need help',
        MANDATORY_MSJ: 'Mandatory',
      },
      PRODUCTS_LIST: {
        TITLE: 'Product Review',
        DELETED_TITLE: 'Removed',
        FRESHNESS_GUARANTEE: 'Which product is not fresh?',
        FRESHNESS_COUNTER_TITLE: 'Select the units'
      },
      ZENDESK_ARTICLE: {
        RETURN_BUTTON: 'Back'
      },
    },
    COMPONENTS: {
      PRODUCT: {
        UNIT: 'Unit',
        UNITS: 'Units',
      },
      INFO_BOX: {
        COPY:
          'Thank you for your feedback! We will use it to improve your experience.',
      },
      ORDER_PRODUCT: {
        UNIT: 'Unit',
        UNITS: 'Units',
        HIDE: 'Hide',
        SHOW: 'Show',
      },
      PRODUCTS_WRAPPER: {
        TITLE: 'What product did you need?'
      }
    },
    COMMON: {
      YES: 'Yes',
      NO: 'No',
      COPY_TO_CLIPBOARD: 'Copied to clipboard',
      PHONE: 'Phone',
      COSTS: 'Costs',
      TIP: 'Tip',
      RAPPI_PAY: 'Rappipay',
      RAPPI_CREDITS: 'Credits',
      MIN_CHARACTERS: {
        TEXT_AREA: 'Text Area',
        BASE:
          '@:COMMON.MIN_CHARACTERS.TEXT_AREA requires a minimum of characters of {minLength}',
      },
      REQUIRED_IMAGE: {
        BASE: 'At least {n} image is required',
      },
      REQUIRED_PRODUCT: {
        BASE: 'You must select at least one product.',
        OVERLOAD:
          'If your order was not delivered, please create the request for undelivered order.',
      },
      REQUIRED_INPUT: 'Please fill in the text field',
      SECONDS: 'Seconds',
      MINUTES: 'Minutes',
      HOURS: 'Hours',
      DAYS: 'Days',
      WAIT_TIME: 'Wait time',
      ERROR_MESSAGE: 'Sorry an error occurred.'
    },
    MODALS: {
      COMPENSATION: {
        COMPENSATION_QUESTION: 'How do you want us to compensate you?',
        RAPPICREDITCS_REFUND: 'Credits refund',
        PRODUCTS_RESHIP: 'Forward of missing products',
        REFUND_TEXT: 'The value of the missing orders was $',
      },
    },
    PAYMENT_METHOD: {
      CASH: 'Cash',
      CC: 'Credit Card',
      DC: 'Debit card',
      PAYPAL: 'PayPal',
      POS_TERMINAL: 'Dataphone',
      TERMINAL: 'Terminal',
      RAPPI_PAY: 'Rappipay',
    },
    MAXLENGTH_MESSAGE: 'Allowed characters',
  },
}
